/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Dry_Fox_MendInputs */

const en_still_dry_fox_mend = /** @type {(inputs: Still_Dry_Fox_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const de_still_dry_fox_mend = /** @type {(inputs: Still_Dry_Fox_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Still_Dry_Fox_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const still_dry_fox_mend = /** @type {((inputs?: Still_Dry_Fox_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Dry_Fox_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_still_dry_fox_mend(inputs)
	return de_still_dry_fox_mend(inputs)
});